import React, {ChangeEvent, useEffect, useState} from 'react';
import {
    authAPI,
} from "../services/AuthService";
import {Alert, AutoComplete, Button, Input, Select, Space, Typography, Upload, UploadProps} from "antd";
import {ArrowLeftOutlined} from "@ant-design/icons";
import {Navigate} from "react-router-dom";
import {ObjectModel} from "../models/ObjectModel";
import {objectAPI} from "../services/ObjectService";
import {ObjectGridModel} from "../models/ObjectGridModel";
import {EquipmentModel} from "../models/EquipmentModel";
import {taskAPI} from "../services/TaskService";
import {host, port, secure} from "../config/config";
import imageCompression from "browser-image-compression";

const {Text} = Typography;
export const CreateTaskScreen: React.FC = () => {
    const [getObjectsRequest, {
        data: dataGetObjectsRequest,
        isLoading: isGettingObjectsInProcess,
        isError,
    }] = objectAPI.useGetMyObjectsMutation();
    const [createTaskRequest, {
        data: dataCreateTask,
        isLoading: createTaskInProcess,
        isError: isErrorCreateTask,
    }] = taskAPI.useCreateTaskMutation();
    // Return to login if reject token verify
    const [verifyTokenRequest, {status: statusVerifyTokenRequest}] = authAPI.useVerifyTokenMutation();
    useEffect(() => {
        verifyTokenRequest();
    }, [])
    useEffect(() => {
        if (statusVerifyTokenRequest === 'rejected') {
            localStorage.clear()
            setRedirectToLogin(true)
        }
    }, [statusVerifyTokenRequest])
    // -----
    const [redirectToLogin, setRedirectToLogin] = useState<boolean>(false);
    const [redirectToClient, setRedirectToClient] = useState<boolean>(false);
    const [redirectToExecutor, setRedirectToExecutor] = useState<boolean>(false);
    const [selectedObject, setSelectedObject] = useState<string>('');
    const [equipments, setEquipments] = useState<{ value: string }[]>([]);
    const [selectedEquipment, setSelectedEquipment] = useState<string>('');
    const [title, setTitle] = useState<string>();
    const [description, setDescription] = useState<string>();
    const [photos, setPhotos] = useState<any>();
    const [errors, setErrors] = useState<string[]>([]);
    const [isLoadingCreateTaskRequest, setIsLoadingCreateTaskRequest] = useState<boolean>(false);
    const [compressedPhotos, setCompressedPhotos] = useState<any[]>([]);
    const compressImage = () => {
        setIsLoadingCreateTaskRequest(true)
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920
        }
        if (photos) {
            if (photos.fileList) {
                photos.fileList.map((file: any, i: any) => {
                    const compressedFile = imageCompression(file.originFileObj, options);
                    compressedFile.then((success) => {
                        setCompressedPhotos(prev => prev.concat(success))
                    })
                })
            }
        } else
            createTaskHandler()
    }
    useEffect(() => {
        if (compressedPhotos.length === photos?.fileList?.length) {
            createTaskHandler()
        }
    }, [compressedPhotos])
    useEffect(() => {
        getObjectsRequest()
    }, []);
    useEffect(() => {
        if (selectedObject && dataGetObjectsRequest) {
            let object: ObjectGridModel | undefined = dataGetObjectsRequest.find((object: ObjectModel) => `${object.name} ${object.filial.code} ${object.filial.name}` === selectedObject)
            if (object) {
                setEquipments(object.equipments.map((equipment: EquipmentModel) => ({value: equipment.name + '#' + equipment.code})))
            } else {
                setEquipments([])
                setSelectedEquipment('')
            }
        }
    }, [selectedObject])
    const createTaskHandler = () => {
        if (!equipments.find((equipment: { value: string }) => equipment.value === selectedEquipment)) {
            setErrors(['Оборудование не найдено, выберите оборудование из списка'])
            setIsLoadingCreateTaskRequest(false)
        }
        else if (selectedObject && selectedEquipment && title) {
            setErrors([])
            let myHeaders = new Headers();
            let object: ObjectGridModel | undefined = dataGetObjectsRequest?.find((object: ObjectModel) => `${object.name} ${object.filial.code} ${object.filial.name}` === selectedObject)
            myHeaders.append("authorization", `Bearer ${localStorage.getItem('token')}`);
            let formData = new FormData();
            //@ts-ignore
            formData.append("object", object.id);
            formData.append("equipment", selectedEquipment);
            formData.append("title", title);
            formData.append("description", description ?? "");

            if (compressedPhotos) {
                compressedPhotos.map((file: any, i: any) => {
                    formData.append(`photo${i}`, file, `photo-${i}.png`);
                })
            }
            let requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formData,
                redirect: 'follow'
            };
            //@ts-ignore
            fetch(`${secure}://${host}${port}/tasks/create`, requestOptions)
                .then(response => {
                    setIsLoadingCreateTaskRequest(false)
                    return response.text()
                })
                .then(result => {
                    setIsLoadingCreateTaskRequest(false)
                    let response = JSON.parse(result);
                    if (response.status === 201) {
                        if (window.location.pathname.indexOf('executor') === -1)
                            setRedirectToClient(true);
                        else
                            setRedirectToExecutor(true)
                    }
                })
                .catch(error => {
                    setIsLoadingCreateTaskRequest(false)
                    setErrors([error])
                });
        } else {
            setIsLoadingCreateTaskRequest(false)
            setErrors(['Некоторые поля не заполнены'])
        }
    };
    const props: UploadProps = {
        beforeUpload(file) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    const img = document.createElement('img');
                    img.src = reader.result as string;
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = img.naturalWidth;
                        canvas.height = img.naturalHeight;
                        const ctx = canvas.getContext('2d')!;
                        ctx.drawImage(img, 0, 0);
                        ctx.fillStyle = 'red';
                        ctx.textBaseline = 'middle';
                        ctx.font = '33px Arial';
                        ctx.fillText('Ant Design', 20, 20);
                        canvas.toBlob((result) => resolve(result as any));
                    };
                };
            });
        },
    };
    return (
        <div style={{padding: 5}}>
            {redirectToLogin && <Navigate to="/login" replace={false}/>}
            {redirectToClient && <Navigate to="/my" replace={false}/>}
            {redirectToExecutor && <Navigate to="/executor" replace={false}/>}
            <Button style={{marginBottom: '15px'}} onClick={() => {
                if (window.location.pathname.indexOf('executor') === -1)
                setRedirectToClient(true);
            else
                setRedirectToExecutor(true)}
            } type="primary"
                    icon={<ArrowLeftOutlined/>}>
                Назад
            </Button>
            <Space direction="vertical" size="middle" style={{display: 'flex'}}>
                <div>
                    <Text style={{fontFamily: 'Roboto'}}>Объект</Text>
                    <AutoComplete
                        disabled={isGettingObjectsInProcess}
                        options={dataGetObjectsRequest ? dataGetObjectsRequest.map((item: ObjectModel) => ({
                            value: `${item.name} ${item.filial.code} ${item.filial.name}`,
                        })) : []}
                        style={{width: '100%'}}
                        onChange={setSelectedObject}
                        filterOption={(inputValue, option) => {
                            let opt = option!.value as unknown as string
                            return opt?.toUpperCase()?.indexOf(inputValue?.toUpperCase()) !== -1
                        }
                        }
                        notFoundContent={'Объект не найден'}
                    />
                </div>
                <div>
                    <Text style={{fontFamily: 'Roboto'}}>Наименование техники/инвентарник</Text>
                    <AutoComplete
                        value={selectedEquipment}
                        onChange={setSelectedEquipment}
                        options={equipments}
                        style={{width: '100%'}}
                        onSelect={setSelectedEquipment}
                        filterOption={(inputValue, option) => {
                            let opt = option!.value as unknown as string
                            return opt?.toUpperCase()?.indexOf(inputValue?.toUpperCase()) !== -1
                        }
                        }
                        notFoundContent={'Оборудование не найдено'}
                    />
                </div>
                <div>
                    <Text style={{fontFamily: 'Roboto'}}>Заявленная неисправность</Text>
                    <Input value={title} onChange={(e) => setTitle(e.target.value)}/>
                </div>
                <div>
                    <Text style={{fontFamily: 'Roboto'}}>Описание неисправности</Text>
                    <Input value={description} onChange={(e) => setDescription(e.target.value)}/>
                </div>
                <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                    <Upload style={{width: '95vw'}}
                            multiple accept={'image/png, image/jpeg'}
                            onChange={(e) => setPhotos(e)}
                            maxCount={3}
                            listType="picture"
                            {...props}
                    >
                        <div style={{display: 'flex', justifyContent: 'space-around', width: '95vw'}}>
                            <Button style={{width: '100%', maxWidth: 250}} type={'primary'}>Нажмите для выбора
                                фото</Button>
                        </div>
                    </Upload>
                    {/*{errors.map((error: string) => {*/}
                    {/*    return (*/}
                    {/*        <Alert style={{width: '100%', maxWidth: 250, marginTop: '20px'}} message={error}*/}
                    {/*               type="error"/>*/}
                    {/*    )*/}
                    {/*})}*/}
                    <Button style={{width: '100%', maxWidth: 250, marginTop: '20px'}}
                            type={'primary'}
                            onClick={() => compressImage()}
                            disabled={isLoadingCreateTaskRequest}
                    >Создать заявку</Button>
                </div>
            </Space>
        </div>
    );
};